import { render } from "./projectUnit.vue?vue&type=template&id=d3dda1f6&scoped=true"
import script from "./projectUnit.vue?vue&type=script&lang=js"
export * from "./projectUnit.vue?vue&type=script&lang=js"

import "./projectUnit.vue?vue&type=style&index=0&id=d3dda1f6&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3dda1f6"]])

export default __exports__